import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useAppAuth } from "../../../context/use-app-auth";
import requets from "../../../api";

export function useColumnsTable(device) {
  const { t } = useTranslation("global");
  const auth = useAppAuth();
  const req = useMemo(() => requets(auth.user?.access_token), [auth.user?.access_token]);
  const [dynamicColumns, setDynamicColumns] = useState([]);

  const staticColumns = useMemo(
    () => [
      {
        title: t("reports.tableColumn.date"),
        dataIndex: "timestamp",
        key: "timestamp",
        fixed: "left",
        width: 175,
        render: (text) => (text ? dayjs(text).format("DD/MM/YYYY HH:mm:ss") : "—"),
      },
    ],
    [t],
  );

  useEffect(() => {
    if (!device?.devEui || !auth.user?.access_token) return;
    req
      .get(`/device/${device.devEui}/measurements`)
      .then((response) => {
        const variables = response.data?.product?.productMeasurements || [];
        const generated = variables.map((item) => {
          const { name, tag, uuid, unit } = item.measurement;
          // Strip the InfluxDB prefix so dataIndex matches the field name
          // from /metrics/{devEui}/history  (e.g. "Temp_Water_1" not "device_frmpayload_data_Temp_Water_1")
          const stripped = (tag || "").replace(/^device_frmpayload_data_/i, "");
          const colKey = stripped || uuid || name;
          return {
            title: unit ? `${name} (${unit})` : name,
            dataIndex: colKey,
            key: colKey,
            align: "right",
            width: 140,
            render: (val) => (val === undefined || val === null ? "—" : Number(val).toLocaleString("es-CO", { maximumFractionDigits: 3 })),
          };
        });
        setDynamicColumns(generated);
      })
      .catch(() => setDynamicColumns([]));
  }, [device?.devEui, auth.user?.access_token]);

  return [...staticColumns, ...dynamicColumns];
}
